// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34gaC","fullView":"styles_fullView__2lAsw"};